import { DataTablePaginate } from '@/common/ui/table/data-table-paginate'
import { DataTableResetFilter } from '@/common/ui/table/data-table-reset-filter'
import { GetInviteFriendCommissionHistoryResponseData } from '@/modules/promotion/type'
import { columns, COMMISSION_TYPE_OPTIONS } from './constants'
import { DataTableSearch } from '@/common/ui/table/data-table-search'
import { DateRangePicker } from '@/common/components/DateRangePicker'
import DateRangeButtons from '@/common/components/DateRangeButtons'
import { parseAsBoolean, parseAsString, useQueryState } from 'nuqs'
import { Label } from '@/common/ui/label'
import { Switch } from '@/common/ui/switch'
import { Button } from '@/common/ui/button'

interface InviteFriendCommissionHistoryTableProps {
	data: GetInviteFriendCommissionHistoryResponseData[]
	total: number
	isLoading?: boolean
}

export default function InviteFriendCommissionHistoryTable({
	data,
	total,
	isLoading,
}: InviteFriendCommissionHistoryTableProps) {
	const [greaterThanZero, setGreaterThanZero] = useQueryState(
		'greaterThanZero',
		parseAsBoolean.withOptions({ shallow: false }).withDefault(true),
	)
	const [commissionType, setCommissionType] = useQueryState(
		'commissionType',
		parseAsString.withOptions({ shallow: false }),
	)

	return (
		<div className="space-y-4">
			<div className="flex flex-wrap items-center gap-4">
				<DataTableSearch placeHolder="ค้นหาเบอร์โทรศัพท์" />
				<DateRangePicker />
				<DateRangeButtons />
				<div className="flex items-center gap-2 rounded-lg border px-3 py-2">
					<Switch
						id="greaterThanZero"
						checked={greaterThanZero}
						onCheckedChange={setGreaterThanZero}
					/>
					<Label htmlFor="greaterThanZero" className="cursor-pointer">
						ยอดคอมมิชชั่นมากกว่า 0
					</Label>
				</div>
				<DataTableResetFilter />
			</div>
			<div className="flex flex-wrap items-center gap-2">
				<span className="text-sm text-muted-foreground">ประเภท:</span>
				<Button
					type="button"
					variant={commissionType === null ? 'default' : 'outline'}
					size="sm"
					onClick={() => setCommissionType(null)}
				>
					ทั้งหมด
				</Button>
				{COMMISSION_TYPE_OPTIONS.map((option) => (
					<Button
						key={option.value}
						type="button"
						variant={commissionType === option.value ? 'default' : 'outline'}
						size="sm"
						onClick={() => setCommissionType(option.value)}
					>
						{option.label}
					</Button>
				))}
			</div>
			<DataTablePaginate
				columns={columns}
				data={data}
				totalItems={total}
				isLoading={isLoading}
			/>
		</div>
	)
}
